// ABOUTME: Edits destination messages and URLs for WhatsApp pre-registration.
// ABOUTME: Keeps future-job and non-recruiting copy together for review.
import React from "react";
import { Box, Divider, Paper, TextField, Typography } from "@material-ui/core";

import { WhatsappPreRegistrationLabels } from "./whatsappPreRegistrationLabels";
import { WhatsappPreRegistrationConfig } from "./whatsappPreRegistrationSettingsModel";

interface WhatsappPreRegistrationMessageCopyProps {
    config: WhatsappPreRegistrationConfig;
    labels: WhatsappPreRegistrationLabels;
    onChange: (config: WhatsappPreRegistrationConfig) => void;
}

const WhatsappPreRegistrationMessageCopy = ({
    config,
    labels,
    onChange
}: WhatsappPreRegistrationMessageCopyProps) => {
    const updateDestination = (
        destination: "futureJobs" | "nonRecruiting",
        field: "text" | "url",
        value: string
    ) => {
        onChange({
            ...config,
            [destination]: {
                ...config[destination],
                [field]: value
            }
        });
    };

    return (
        <Paper elevation={0} style={{ padding: 24, height: "100%" }}>
            <Typography variant="h6">{labels.destinations}</Typography>
            <Box mt={2}>
                <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    variant="outlined"
                    label={labels.futureJobsText}
                    value={config.futureJobs.text}
                    onChange={(event) =>
                        updateDestination(
                            "futureJobs",
                            "text",
                            event.target.value
                        )
                    }
                />
            </Box>
            <Box mt={2}>
                <TextField
                    fullWidth
                    variant="outlined"
                    label={labels.futureJobsUrl}
                    value={config.futureJobs.url}
                    onChange={(event) =>
                        updateDestination(
                            "futureJobs",
                            "url",
                            event.target.value
                        )
                    }
                />
            </Box>
            <Box my={3}>
                <Divider />
            </Box>
            <TextField
                fullWidth
                multiline
                minRows={3}
                variant="outlined"
                label={labels.nonRecruitingText}
                value={config.nonRecruiting.text}
                onChange={(event) =>
                    updateDestination(
                        "nonRecruiting",
                        "text",
                        event.target.value
                    )
                }
            />
            <Box mt={2}>
                <TextField
                    fullWidth
                    variant="outlined"
                    label={labels.nonRecruitingUrl}
                    value={config.nonRecruiting.url}
                    onChange={(event) =>
                        updateDestination(
                            "nonRecruiting",
                            "url",
                            event.target.value
                        )
                    }
                />
            </Box>
        </Paper>
    );
};

export default WhatsappPreRegistrationMessageCopy;
